import { defineComponent as he, toRef as u, ref as b, computed as c, watch as N, nextTick as ge, onBeforeUnmount as pe, provide as z, onMounted as ye, h as a } from "vue";
import be from "./ghl-ui.es1160.js";
import k from "./ghl-ui.es1498.js";
import O from "./ghl-ui.es1499.js";
import { internalSelectionMenuInjectionKey as Se, internalSelectionMenuBodyInjectionKey as Re } from "./ghl-ui.es1430.js";
import Fe from "./ghl-ui.es1500.js";
import w from "./ghl-ui.es888.js";
import xe from "./ghl-ui.es1189.js";
import { createIndexGetter as Te } from "./ghl-ui.es1155.js";
import { depx as Ce, getMargin as R } from "./ghl-ui.es770.js";
import { createKey as y } from "./ghl-ui.es739.js";
import { useThemeClass as Me } from "./ghl-ui.es889.js";
import { useOnResize as Pe } from "./ghl-ui.es1162.js";
import Ne from "./ghl-ui.es924.js";
import ze from "./ghl-ui.es1011.js";
import ke from "./ghl-ui.es214.js";
import { resolveSlot as Oe, resolveWrappedSlot as we } from "./ghl-ui.es892.js";
import { happensIn as B } from "./ghl-ui.es995.js";
import Be from "./ghl-ui.es1025.js";
const Ze = he({
  name: "InternalSelectMenu",
  props: Object.assign(Object.assign({}, w.props), {
    clsPrefix: {
      type: String,
      required: !0
    },
    scrollable: {
      type: Boolean,
      default: !0
    },
    treeMate: {
      type: Object,
      required: !0
    },
    multiple: Boolean,
    size: {
      type: String,
      default: "medium"
    },
    value: {
      type: [String, Number, Array],
      default: null
    },
    autoPending: Boolean,
    virtualScroll: {
      type: Boolean,
      default: !0
    },
    // show is used to toggle pending state initialization
    show: {
      type: Boolean,
      default: !0
    },
    labelField: {
      type: String,
      default: "label"
    },
    valueField: {
      type: String,
      default: "value"
    },
    loading: Boolean,
    focusable: Boolean,
    renderLabel: Function,
    renderOption: Function,
    nodeProps: Function,
    showCheckmark: { type: Boolean, default: !0 },
    onMousedown: Function,
    onScroll: Function,
    onFocus: Function,
    onBlur: Function,
    onKeyup: Function,
    onKeydown: Function,
    onTabOut: Function,
    onMouseenter: Function,
    onMouseleave: Function,
    onResize: Function,
    resetMenuOnOptionsChange: {
      type: Boolean,
      default: !0
    },
    inlineThemeDisabled: Boolean,
    // deprecated
    onToggle: Function
  }),
  setup(t) {
    const r = w("InternalSelectMenu", "-internal-select-menu", Fe, xe, t, u(t, "clsPrefix")), o = b(null), d = b(null), f = b(null), v = c(() => t.treeMate.getFlattenedNodes()), i = c(() => Te(v.value)), s = b(null);
    function _() {
      const { treeMate: e } = t;
      let n = null;
      const { value: l } = t;
      l === null ? n = e.getFirstAvailableNode() : (t.multiple ? n = e.getNode((l || [])[(l || []).length - 1]) : n = e.getNode(l), (!n || n.disabled) && (n = e.getFirstAvailableNode())), g(n || null);
    }
    function F() {
      const { value: e } = s;
      e && !t.treeMate.getNode(e.key) && (s.value = null);
    }
    let m;
    N(() => t.show, (e) => {
      e ? m = N(() => t.treeMate, () => {
        t.resetMenuOnOptionsChange ? (t.autoPending ? _() : F(), ge(C)) : F();
      }, {
        immediate: !0
      }) : m == null || m();
    }, {
      immediate: !0
    }), pe(() => {
      m == null || m();
    });
    const x = c(() => Ce(r.value.self[y("optionHeight", t.size)])), L = c(() => R(r.value.self[y("padding", t.size)])), K = c(() => t.multiple && Array.isArray(t.value) ? new Set(t.value) : /* @__PURE__ */ new Set()), I = c(() => {
      const e = v.value;
      return e && e.length === 0;
    });
    function D(e) {
      const { onToggle: n } = t;
      n && n(e);
    }
    function T(e) {
      const { onScroll: n } = t;
      n && n(e);
    }
    function A(e) {
      var n;
      (n = f.value) === null || n === void 0 || n.sync(), T(e);
    }
    function V() {
      var e;
      (e = f.value) === null || e === void 0 || e.sync();
    }
    function $() {
      const { value: e } = s;
      return e || null;
    }
    function E(e, n) {
      n.disabled || g(n, !1);
    }
    function H(e, n) {
      n.disabled || D(n);
    }
    function j(e) {
      var n;
      B(e, "action") || (n = t.onKeyup) === null || n === void 0 || n.call(t, e);
    }
    function G(e) {
      var n;
      B(e, "action") || (n = t.onKeydown) === null || n === void 0 || n.call(t, e);
    }
    function U(e) {
      var n;
      (n = t.onMousedown) === null || n === void 0 || n.call(t, e), !t.focusable && e.preventDefault();
    }
    function W() {
      const { value: e } = s;
      e && g(e.getNext({ loop: !0 }), !0);
    }
    function q() {
      const { value: e } = s;
      e && g(e.getPrev({ loop: !0 }), !0);
    }
    function g(e, n = !1) {
      s.value = e, n && C();
    }
    function C() {
      var e, n;
      const l = s.value;
      if (!l)
        return;
      const p = i.value(l.key);
      p !== null && (t.virtualScroll ? (e = d.value) === null || e === void 0 || e.scrollTo({ index: p }) : (n = f.value) === null || n === void 0 || n.scrollTo({
        index: p,
        elSize: x.value
      }));
    }
    function J(e) {
      var n, l;
      !((n = o.value) === null || n === void 0) && n.contains(e.target) && ((l = t.onFocus) === null || l === void 0 || l.call(t, e));
    }
    function Q(e) {
      var n, l;
      !((n = o.value) === null || n === void 0) && n.contains(e.relatedTarget) || (l = t.onBlur) === null || l === void 0 || l.call(t, e);
    }
    z(Se, {
      handleOptionMouseEnter: E,
      handleOptionClick: H,
      valueSetRef: K,
      pendingTmNodeRef: s,
      nodePropsRef: u(t, "nodeProps"),
      showCheckmarkRef: u(t, "showCheckmark"),
      multipleRef: u(t, "multiple"),
      valueRef: u(t, "value"),
      renderLabelRef: u(t, "renderLabel"),
      renderOptionRef: u(t, "renderOption"),
      labelFieldRef: u(t, "labelField"),
      valueFieldRef: u(t, "valueField")
    }), z(Re, o), ye(() => {
      const { value: e } = f;
      e && e.sync();
    });
    const M = c(() => {
      const { size: e } = t, { common: { cubicBezierEaseInOut: n }, self: { height: l, borderRadius: p, color: Y, groupHeaderTextColor: Z, actionDividerColor: ee, optionTextColorPressed: ne, optionTextColor: te, optionTextColorDisabled: oe, optionTextColorActive: ie, optionOpacityDisabled: le, optionCheckColor: ae, actionTextColor: re, optionColorPending: de, optionColorActive: ue, loadingColor: se, loadingSize: ce, optionColorActivePending: fe, [y("optionFontSize", e)]: ve, [y("optionHeight", e)]: me, [y("optionPadding", e)]: S } } = r.value;
      return {
        "--n-height": l,
        "--n-action-divider-color": ee,
        "--n-action-text-color": re,
        "--n-bezier": n,
        "--n-border-radius": p,
        "--n-color": Y,
        "--n-option-font-size": ve,
        "--n-group-header-text-color": Z,
        "--n-option-check-color": ae,
        "--n-option-color-pending": de,
        "--n-option-color-active": ue,
        "--n-option-color-active-pending": fe,
        "--n-option-height": me,
        "--n-option-opacity-disabled": le,
        "--n-option-text-color": te,
        "--n-option-text-color-active": ie,
        "--n-option-text-color-disabled": oe,
        "--n-option-text-color-pressed": ne,
        "--n-option-padding": S,
        "--n-option-padding-left": R(S, "left"),
        "--n-option-padding-right": R(S, "right"),
        "--n-loading-color": se,
        "--n-loading-size": ce
      };
    }), { inlineThemeDisabled: P } = t, h = P ? Me("internal-select-menu", c(() => t.size[0]), M, t) : void 0, X = {
      selfRef: o,
      next: W,
      prev: q,
      getPendingTmNode: $
    };
    return Pe(o, t.onResize), Object.assign({
      mergedTheme: r,
      virtualListRef: d,
      scrollbarRef: f,
      itemSize: x,
      padding: L,
      flattenedNodes: v,
      empty: I,
      virtualListContainer() {
        const { value: e } = d;
        return e == null ? void 0 : e.listElRef;
      },
      virtualListContent() {
        const { value: e } = d;
        return e == null ? void 0 : e.itemsElRef;
      },
      doScroll: T,
      handleFocusin: J,
      handleFocusout: Q,
      handleKeyUp: j,
      handleKeyDown: G,
      handleMouseDown: U,
      handleVirtualListResize: V,
      handleVirtualListScroll: A,
      cssVars: P ? void 0 : M,
      themeClass: h == null ? void 0 : h.themeClass,
      onRender: h == null ? void 0 : h.onRender
    }, X);
  },
  render() {
    const { $slots: t, virtualScroll: r, clsPrefix: o, mergedTheme: d, themeClass: f, onRender: v } = this;
    return v == null || v(), a(
      "div",
      { ref: "selfRef", tabindex: this.focusable ? 0 : -1, class: [
        `${o}-base-select-menu`,
        f,
        this.multiple && `${o}-base-select-menu--multiple`
      ], style: this.cssVars, onFocusin: this.handleFocusin, onFocusout: this.handleFocusout, onKeyup: this.handleKeyUp, onKeydown: this.handleKeyDown, onMousedown: this.handleMouseDown, onMouseenter: this.onMouseenter, onMouseleave: this.onMouseleave },
      this.loading ? a(
        "div",
        { class: `${o}-base-select-menu__loading` },
        a(Ne, { clsPrefix: o, strokeWidth: 20 })
      ) : this.empty ? a("div", { class: `${o}-base-select-menu__empty`, "data-empty": !0, "data-action": !0 }, Oe(t.empty, () => [
        a(Be, { theme: d.peers.Empty, themeOverrides: d.peerOverrides.Empty })
      ])) : a(ze, { ref: "scrollbarRef", theme: d.peers.Scrollbar, themeOverrides: d.peerOverrides.Scrollbar, scrollable: this.scrollable, container: r ? this.virtualListContainer : void 0, content: r ? this.virtualListContent : void 0, onScroll: r ? void 0 : this.doScroll }, {
        default: () => r ? a(ke, { ref: "virtualListRef", class: `${o}-virtual-list`, items: this.flattenedNodes, itemSize: this.itemSize, showScrollbar: !1, paddingTop: this.padding.top, paddingBottom: this.padding.bottom, onResize: this.handleVirtualListResize, onScroll: this.handleVirtualListScroll, itemResizable: !0 }, {
          default: ({ item: i }) => i.isGroup ? a(O, { key: i.key, clsPrefix: o, tmNode: i }) : i.ignored ? null : a(k, { clsPrefix: o, key: i.key, tmNode: i })
        }) : a("div", { class: `${o}-base-select-menu-option-wrapper`, style: {
          paddingTop: this.padding.top,
          paddingBottom: this.padding.bottom
        } }, this.flattenedNodes.map((i) => i.isGroup ? a(O, { key: i.key, clsPrefix: o, tmNode: i }) : a(k, { clsPrefix: o, key: i.key, tmNode: i })))
      }),
      we(t.action, (i) => i && [
        a("div", { class: `${o}-base-select-menu__action`, "data-action": !0, key: "action" }, i),
        a(be, { onFocus: this.onTabOut, key: "focus-detector" })
      ])
    );
  }
});
export {
  Ze as default
};
